export default {"src":"/_next/static/media/twitter.d76f519e.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};